import { render, staticRenderFns } from "./PageDashboard.vue?vue&type=template&id=06096c2c&scoped=true"
import script from "./PageDashboard.vue?vue&type=script&lang=js"
export * from "./PageDashboard.vue?vue&type=script&lang=js"
import style0 from "./PageDashboard.vue?vue&type=style&index=0&id=06096c2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06096c2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06096c2c')) {
      api.createRecord('06096c2c', component.options)
    } else {
      api.reload('06096c2c', component.options)
    }
    module.hot.accept("./PageDashboard.vue?vue&type=template&id=06096c2c&scoped=true", function () {
      api.rerender('06096c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PageDashboard.vue"
export default component.exports